import React, { useContext, useMemo, useState } from 'react'
import { ReactComponent as ArrowIcon } from './icons/arrow.svg'
import { getLevelName } from '../../../../../helpers/levels'
import useDetectDevice from '../../../../../hooks/useDetectDevice'
import BottomSheet from '../../../../BottomSheet'
import { getLineAsFloorName, getLineName } from '../../../../../helpers/line'
import { AppConfigContext } from '../../../../../context/AppConfig'

function OfficesLinePicker({ onLineSelected, selectedLine, property }) {
  const { isDesktop, isMobile } = useDetectDevice()
const {single_line} = useContext(AppConfigContext)

  let lines = useMemo(() => {
    if (!property) {
      return []
    }
    return property.unit_types.map((unit_type) => ({
      id: unit_type.id,
      data: unit_type,
      label: getLineAsFloorName(unit_type),
    }))
  }, [property])

  const [toggled, setToggled] = useState(false)
  return (
    <>
      {selectedLine && (
        <div className="relative">
          <button
            type="button"
            className={`landscape:w-full bg-[#fff] rounded-[6px] lg:border-[1px] border-[#C7CCD9] border-solid lg:border-none lg:shadow-sm h-[50px] lg:h-[40px]  lg:pl-[16px] flex items-center justify-between max-w-[400px] relative ${
              lines.length > 1 && !single_line ? 'cursor-pointer pl-[8px] border-[1px]' : 'pointer-events-none'
            }`}
            onClick={() => setToggled(!toggled)}
          >
            <div className="font-medium flex items-center  w-full justify-between">
              <div className={`${lines.length > 1 ? 'mr-[8px]' : ''} lg:mr-[16px] text-[14px] flex flex-col lg:block items-start `}>
                <span className="text-[#3D4256]">{getLineAsFloorName(selectedLine)}</span>

                {selectedLine.size_to_display && (
                  <span className="text-[#3D425699] text-[14px] mt-[-2px] lg:mt-0">
                    <span className="mx-[4px] hidden lg:inline">·</span>
                    <span>{selectedLine.size_to_display} SF</span>
                  </span>
                )}
              </div>

              {lines.length > 1 && !single_line && (
                <div className="flex items-center w-[34px]">
                  <div className="w-[1px] bg-[#C7CCD9] h-[50px] lg:h-[32px] shrink-0"></div>
                  <div className="mx-[10px] w-[calc(30px-1px)] flex items-center justify-center">
                    <div className="rotate-[-90deg] lg:rotate-0">
                      <ArrowIcon />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </button>
          {isDesktop && (
            <>
              {toggled && (
                <div className="absolute w-full max-h-[600px] overflow-y-auto bg-[#fff] top-[55px] rounded-[6px] shadow-sm p-[4px]">
                  {lines.map((line) => (
                    <button
                      type="button"
                      onClick={() => {
                        onLineSelected(line)
                        setToggled(false)
                      }}
                      className={`w-full ${
                        line.data.id === selectedLine?.id ? 'bg-[#E5E7EDB2]' : ''
                      } hover:bg-[#E5E7EDB2] rounded-[2px] text-[14px] font-medium px-[8px] h-[46px] flex justify-center flex-col mt-[4px] first:mt-0`}
                    >
                      <div className=""> {line.label}</div>
                      {line.size_to_display && (
                        <div className="text-[#3D425666]">{selectedLine.size_to_display} SF</div>
                      )}
                    </button>
                  ))}
                </div>
              )}
            </>
          )}
          {isMobile && (
            <>
              <BottomSheet
                onToggle={() => {
                  setToggled(!toggled)
                }}
                open={toggled}
                title="Choose Floor Plan Type"
              >
                {lines
                  // .filter((l) => l.id !== selectedLevel.id)
                  .map((line) => (
                    <button
                      type="button"
                      onClick={() => {
                        onLineSelected(line)
                        setToggled(false)
                      }}
                      className="hover:bg-[#e4e4e4] text-left py-[20px] font-medium text-[#3D4256] border-t-[1px] flex items-center justify-between w-full border-solid border-[#E5E7ED] first:border-t-0"
                    >
                      {line.label}
                    </button>
                  ))}
              </BottomSheet>
            </>
          )}
        </div>
      )}
    </>
  )
}

export default OfficesLinePicker
